// extracted by mini-css-extract-plugin
module.exports = {"attributionContainer":"WeatherAttribution_attributionContainer__8NS2i","attributionText":"WeatherAttribution_attributionText__2ScDR"};